// Types
import HistoryTime from 'components/HistoryTime';
// Utils
import { getText } from 'i18n/intl';
import _ from 'lodash';
import { EPeriodAccess } from '@timeedit/types/lib/enums';
import type { TPeriod } from '@timeedit/types/lib/types';
// Components
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

export interface TInfoProps {
  data: TPeriod;
  onChange: (key: string, value: any) => void;
}

const PaddingRuleInfo = (props: TInfoProps) => {
  const { data, onChange } = props;
  return (
    <TEDrawerSection label="General info">
      <div className="section-col">
        <TEInput.PureText label="Id" tooltip="Id" value={String(data.id)} />
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={data.name}
          onChange={(val) => onChange('name', val)}
          placeholder="Name"
          data-testid="period-name"
        />
        <TEInput.Input
          label="Short Name"
          tooltip="Short Name"
          value={data.shortName}
          onChange={(val) => onChange('shortName', val)}
          placeholder="New period short name"
          data-testid="period-shortName"
        />
        <TEInput.Select
          label="User Access Level"
          tooltip="User Access Level"
          value={data.userAccess}
          options={Object.values(EPeriodAccess).map((userAccess) => ({
            value: userAccess,
            label: getText(userAccess),
          }))}
          onChange={(val) => onChange('userAccess', val)}
          data-testid="period-userAccess"
        />
        <TEInput.TextArea
          label="Description"
          tooltip="Description"
          value={data.description}
          onChange={(val) => onChange('description', val)}
          data-testid="period-desc"
        />
      </div>
      <HistoryTime history={data?.history} />
    </TEDrawerSection>
  );
};

export default PaddingRuleInfo;
